import { useCallback, useEffect, useRef, useState } from 'react';
import { trackEvent } from '../../../analytics/sml/analytics';

/** How long "Copied" shows after a copy. */
const COPIED_MS = 1800;

/**
 * Copies a text to the clipboard. `copied` names the last key that was copied, for "Copied" on
 * that button, and clears after a short time.
 */
export function useCopyText(): { copy: (key: string, text: string) => void; copied: string | null } {
  const [copied, setCopied] = useState<string | null>(null);
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(
    () => () => {
      if (timer.current !== null) {
        clearTimeout(timer.current);
      }
    },
    []
  );
  const copy = useCallback((key: string, text: string) => {
    const clipboard = typeof navigator === 'undefined' ? undefined : navigator.clipboard;
    if (clipboard === undefined) {
      return;
    }
    clipboard
      .writeText(text)
      .then(() => {
        setCopied(key);
        trackEvent('link_copied', { kind: 'bio' });
        if (timer.current !== null) {
          clearTimeout(timer.current);
        }
        timer.current = setTimeout(() => setCopied(null), COPIED_MS);
      })
      .catch(console.error);
  }, []);
  return { copy, copied };
}
